import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold text-accent-700 bg-accent-100 rounded-full mb-4">
            Browse All Categories
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            Trending Pandabuy Spreadsheet Categories
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Explore our curated collection of verified Pandabuy finds across every category. Click any category to start shopping.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col bg-background-50 border border-background-200/70 hover:border-primary-300 rounded-xl overflow-hidden transition-all duration-200 cursor-pointer hover:bg-background-100"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src={cat.image}
                  alt={`${cat.name} - Pandabuy Spreadsheet category`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/15 to-transparent"></div>
              </div>
              <div className="p-4 flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors duration-200">
                  <i className={`${cat.icon} text-lg`}></i>
                </span>
                <div className="min-w-0">
                  <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap block truncate">
                    {cat.name}
                  </span>
                  <span className="text-xs text-foreground-500 leading-relaxed hidden sm:block">
                    {cat.description}
                  </span>
                </div>
                <i className="ri-arrow-right-line text-foreground-400 group-hover:text-primary-500 flex-shrink-0 ml-auto transition-colors"></i>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
          >
            Browse All Categories
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}